import { useTranslate } from "ra-core";
import { TasksListContent } from "./TasksListContent";
import { AddTask } from "./AddTask";

/** Desktop tasks page — same content as the dashboard tasks card. */
export const TasksListPage = () => {
  const translate = useTranslate();
  return (
    <div className="p-4 max-w-3xl mx-auto w-full">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-semibold">
          {translate("resources.tasks.name", { smart_count: 2 })}
        </h1>
        <AddTask />
      </div>
      <TasksListContent />
    </div>
  );
};
